export const euro = (v) => {
  const n = Math.round((Number(v) || 0) * 100) / 100;
  return Number.isInteger(n) ? `${n}` : n.toFixed(2).replace(".", ",");
};

export const dateLabel = (iso, opts = { weekday: "long", day: "numeric", month: "long" }) =>
  iso ? new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", opts) : "";

export const LOYALTY_GOAL = 10;
export const LOYALTY_EMAIL_KEY = "bany_loyalty_email";
export const LOYALTY_DISMISS_KEY = "bany_loyalty_dismissed";
export const OPEN_LOYALTY_EVENT = "bany:open-loyalty";
export const openLoyalty = (e) => {
  e?.preventDefault();
  window.dispatchEvent(new Event(OPEN_LOYALTY_EVENT));
};
